export const SHIPPING_COST_MESSAGES_SUCCESS = {
  SAVE_SUCCESS: "Costo de envío guardado exitosamente.",
  DISABLE_SUCCESS: "Costo de envío deshabilitado exitosamente.",
  ENABLE_SUCCESS: "Costo de envío habilitado exitosamente.",
};

export const SHIPPING_COST_MESSAGES_ERROR = {
  SAVE_ERROR: "Error al guardar el costo de envío. Por favor, inténtalo de nuevo.",
  DISABLE_ERROR:
    "Error al deshabilitar el costo de envío. Por favor, inténtalo de nuevo.",
  ENABLE_ERROR:
    "Error al habilitar el costo de envío. Por favor, inténtalo de nuevo.",
};
